<template>
  <b-container class="consent-type-section-container" fluid>
    <b-row
      ><span class="consent-type-heading">
        How will participants consent?
      </span></b-row
    >
    <b-row class="pt-10">
      <b-col class="pl-0 consent-type-label" cols="4">During registration</b-col>
      <b-col cols="8">
        <label class="switch-toggle-btn">
          <input type="checkbox" v-if="datavantStatus" v-model="studyData.consentEnabled" @change="datavantStatus()" disabled />
          <input type="checkbox" v-if="!datavantStatus" v-model="studyData.consentEnabled" @change="sendIfAnyConsentSelected($event)" />
          <div class="slider" v-bind:class="{inactive: datavantStatus}"></div>
          <div class="text"></div>
        </label>
      </b-col>
    </b-row>
    <b-row>
      <b-col class="pl-0 consent-type-label" cols="4">After registration</b-col>
      <b-col cols="8">
        <label class="switch-toggle-btn">
          <input type="checkbox" v-if="datavantStatus" @change="datavantStatusEvent()" disabled >
          <input type="checkbox" v-if="!datavantStatus" v-model="studyData.afterRegistrationConsentEnabled" @change="sendIfAnyConsentSelected($event)">
          <div class="slider"></div>
          <div class="text"></div>
        </label>
      </b-col>
    </b-row>
    <b-row>
      <b-col class="pl-0 consent-type-label" cols="4">No consent is required</b-col>
      <b-col cols="8">
        <label class="switch-toggle-btn">
          <input type="checkbox" v-if="datavantStatus" @change="datavantStatusEvent()" disabled>
          <input type="checkbox" v-if="!datavantStatus" v-model="noConsentToggle" @change="sendNoConsentSelected()">
          <div class="slider"></div>
          <div class="text"></div>
        </label>
      </b-col>
    </b-row>
  </b-container>
</template>
<script>
import { cloneDeep } from "lodash";

export default {
  name: "study-consent-type-section",
  props: {
    studyDetails: {
      type: Object,
      default: null,
      required: false
    },
    datavantStatus: {
      type: Boolean,
      default: null,
      required: false
    }
  },
  watch: {
    deep: true,
    studyDetails: function(oldData) {
      if (oldData) {
        this.studyData = cloneDeep(oldData);

        if (this.studyData.consentEnabled) {
          this.noConsentToggle = false;
        }
        this.repopulateSwitches();
      }
    }
  },
  data() {
    return {
      studyData: {
        consentEnabled: false,
        afterRegistrationConsentEnabled: false
      },
      noConsentToggle: false
    };
  },
  methods: {
    datavantStatusEvent() {
      if (datavantStatus) {
        this.studyData.consentEnabled = true;
        this.studyData.afterRegistrationConsentEnabled = false;
        this.noConsentToggle = false;
      }
    },
    repopulateSwitches() {
      this.manageSwicthWhenNoConsentSelected();
      this.manageSwitchWhenAnyConsentingChanges();
    },
    sendNoConsentSelected() {
      this.manageSwicthWhenNoConsentSelected();
      this.manageSwitchWhenNoConsentisFalse();
      this.selectStudyConsentType();
    },
    sendIfAnyConsentSelected() {
      this.manageSwitchWhenAnyConsentingChanges();
      this.selectStudyConsentType();
    },
    manageSwicthWhenNoConsentSelected() {
      if (this.noConsentToggle) {
        this.studyData.consentEnabled = false;
        this.studyData.afterRegistrationConsentEnabled = false;
      }
    },
    manageSwitchWhenNoConsentisFalse() {
      if (!this.noConsentToggle) {
        this.studyData.consentEnabled = true;
        this.studyData.afterRegistrationConsentEnabled = true;
      }
    },
    manageSwitchWhenAnyConsentingChanges() {
      if (this.studyData.consentEnabled || this.studyData.afterRegistrationConsentEnabled) {
        this.noConsentToggle = false;
      }

      if (!this.studyData.consentEnabled && !this.studyData.afterRegistrationConsentEnabled) {
        this.noConsentToggle = true;
      }
    },
    selectStudyConsentType() {
      const consentTypeObj = {
        consentEnabled: this.studyData.consentEnabled,
        duringRegistrationConsentEnabled: this.studyData.consentEnabled,
        afterRegistrationConsentEnabled: this.studyData.afterRegistrationConsentEnabled
      };

      this.$emit("set-study-consent-type", consentTypeObj);
    }
  }
};
</script>
<style lang="scss" scoped>
.consent-type-section-container {
  width: auto;
  margin-top: 40px;
  margin-left: 30px;
  margin-right: 30px;
  padding-bottom: 10px;
  padding-top: 20px;
  border: solid 1px #e4e8eb;
  border-bottom: none;
  padding-left: 20px;
  border-radius: 3px 3px 0px 0px;

  .consent-type-heading {
    font-family: Lato-Regular;
    font-size: 22px;
    font-weight: bold;
    font-style: normal;
    font-stretch: normal;
    line-height: 1.21;
    letter-spacing: normal;
    color: #2d3752;
  }

  .pl-0 {
    padding-left: 0px !important;
  }

  .consent-type-label {
    font-family: Roboto-Regular;
    font-size: 15px;
    text-align: left;
    color: #4a4a4a;
  }
}
/* toggle btn css - START */
.switch-toggle-btn {
  position: relative;
  display: inline-block;
  width: 56px;
  height: 24px;
  font-size: 14px;
  top: -2px;
  left: 10px;
  &:hover {
    cursor: pointer;
  }
}
.switch-toggle-btn input {
  opacity: 0;
}

.switch-toggle-btn .slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #b0bac9;
  -webkit-transition: 0.4s;
  transition: 0.4s;
  border-radius: 16px;
}

.switch-toggle-btn .slider:before {
  position: absolute;
  content: "";
  height: 18px;
  width: 18px;
  left: 4px;
  top: 3px;
  background-color: #fff;
  -webkit-transition: 0.4s;
  transition: 0.4s;
  border-radius: 50%;
}

.switch-toggle-btn input:checked + .slider {
  background-color: #2ecd6c;
}

.switch-toggle-btn input:focus + .slider {
  box-shadow: 0 0 1px #2ecd6c;
}

.switch-toggle-btn input:checked + .slider:before {
  position: absolute;
  content: "";
  height: 18px;
  width: 18px;
  left: -41px;
  bottom: -1px;
  top: 3px;
  background-color: #fff;
  -webkit-transition: 0.4s;
  transition: 0.4s;
  border-radius: 50%;
  -webkit-transform: translateX(75px);
  -ms-transform: translateX(75px);
  transform: translateX(75px);
}

.switch-toggle-btn .text {
  color: white;
}

.switch-toggle-btn .text:after {
  position: absolute;
  top: 1px;
  right: 10px;
  content: "Off";
  color: #fff;
  -webkit-transition: opacity 0.5s ease-in-out;
  -moz-transition: opacity 0.5s ease-in-out;
  transition: opacity 0.5s ease-in-out;
}

.switch-toggle-btn .text:before {
  position: absolute;
  top: 1px;
  left: 10px;
  content: "On";
  color: #fff;
  -webkit-transition: opacity 0.5s ease-in-out;
  -moz-transition: opacity 0.5s ease-in-out;
  transition: opacity 0.5s ease-in-out;
}

.switch-toggle-btn input + .slider + .text:after {
  opacity: 1;
}

.switch-toggle-btn input + .slider + .text:before {
  opacity: 0;
}

.switch-toggle-btn input:checked + .slider + .text:after {
  opacity: 0;
}

.switch-toggle-btn input:checked + .slider + .text:before {
  opacity: 1;
}
.inactive {
  opacity: 0.5;
}
/* toggle btn css - END */
</style>
